module.exports = __webpack_public_path__ + "img/cjfwU12.ca8b5176.png";